import circleCultured from '../../assets/circle-solid-cultured-100.png';
import circleOceanGreen from '../../assets/circle-solid-ocean-green-100.png';
import circleJellyBean from '../../assets/circle-solid-jelly-bean-100.png';

import styles from '../../styles/base_components/Legend.module.scss';

function Legend(props) {
  return (
    <div className={styles.legend}>
      <div>
        <img src={circleCultured} alt='Cultured circle solid'/>
        <p>enabled</p>
      </div>
      <div>
        <img src={circleOceanGreen} alt='Cultured circle solid'/>
        <p>enabled & autorun</p>
      </div>
      <div>
        <img src={circleJellyBean} alt='Cultured circle solid'/>
        <p>disabled</p>
      </div>
    </div>
  );
}

export default Legend;